import { render } from "./MSHistoryPanel.vue?vue&type=template&id=cdef7e20&scoped=true&ts=true"
import script from "./MSHistoryPanel.vue?vue&type=script&lang=ts"
export * from "./MSHistoryPanel.vue?vue&type=script&lang=ts"

import "./MSHistoryPanel.vue?vue&type=style&index=0&id=cdef7e20&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdef7e20"]])

export default __exports__